module.exports = __webpack_public_path__ + "img/150.346301df.png";